import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { PersonalInfo } from '../components/profil/PersonalInfo';
import { AddressList } from '../components/profil/AddressList';
import { AccountNav, type PanelId } from '../components/profil/AccountNav';
import { AtnaHelp } from '../components/profil/AtnaHelp';
import { AccountManagement } from '../components/profil/AccountManagement';
import { AccountPanel } from '../components/profil/AccountPanel';
export function MonProfil() {
  const [panel, setPanel] = useState<PanelId | null>(null);
  return <main id="profile" className="bg-white" data-id="element-2133" data-mp="ul52e3erq2ck">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2134" data-mp="uisl7sgu3w0k">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2135" data-mp="pmbmy5fx819r">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2136" data-mp="2wcrvqbm4u9c7">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2137" data-mp="2rf9nknfxvy59" />
          <span aria-current="page" data-id="element-2138" data-mp="1cfz8sol6732o">My Profile</span>
        </nav>

        <header className="mt-4" data-id="element-2139" data-mp="1hd7wt5t021bu">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2140" data-mp="1he973826yjsi">My Profile</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2141" data-mp="1mbj5hd7k65sh">
            Manage your personal information, your preferences and your privacy options.
          </p>
        </header>

        <div className="mt-8 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,360px)] lg:gap-10" data-id="element-2142" data-mp="1v4cq7q5rxxdq">
          <div data-id="element-2143" data-mp="202xrzu0ocp4a">
            <PersonalInfo data-id="element-2144" data-mp="202e847rgrqnm" />
            <AddressList data-id="element-2145" data-mp="253bxp5eszmz5" />
            <div className="mt-6 flex justify-end" data-id="element-2146" data-mp="253265de417rc">
              <button type="button" className="rounded-full bg-ville-navy px-7 py-3 text-base font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2147" data-mp="2518wrqc449fn">
                Save
              </button>
            </div>
          </div>

          <div data-id="element-2148" data-mp="7ohavo1e4v86">
            <AccountNav onOpen={setPanel} data-id="element-2149" data-mp="7o7somml7sd1" />
            <AtnaHelp data-id="element-2150" data-mp="2ouwhb9tt8xs" />
          </div>
        </div>

        <AccountManagement data-id="element-2151" data-mp="2q627gmu0qrj" />
      </div>

      <AccountPanel panel={panel} onClose={() => setPanel(null)} data-id="element-2152" data-mp="hlvntdo3v1vq" />
    </main>;
}